import { render, staticRenderFns } from "./AddVideos.vue?vue&type=template&id=4e748eb9&scoped=true"
import script from "./AddVideos.vue?vue&type=script&lang=js"
export * from "./AddVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e748eb9",
  null
  
)

export default component.exports